import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import styles from './PayResult.module.css'

const useStyles = makeStyles({
  root: {
    padding: '16px',
    margin: '45px auto 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',
    boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.16);',
    width: 492,
    height: 444,
    borderRadius: '10px',
    '@media(max-width: 800px)': {
      margin: '35px auto 10px',
    },
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 32,
    fontWeight: 600,
    color: '#ff1f54',
    margin: '15px auto 10px',
    '@media (max-width: 800px)': {
      fontSize: 24,
    },
  },
  title2: {
    fontWeight: 500,
    fontSize: '20px',
    borderBottom: '1px solid #c6c6c6',
    borderWidth: '90px',
    padding: '30px',
    width: '85%',
    textAlign: 'center',
    '@media (max-width: 800px)': {
      fontSize: 14,
      padding: '20px',
    },
  },
  pos: {
    marginBottom: 12,
  },
  cardWrap: {
    padding: '16px',
    margin: '45px auto 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',
    '@media (max-width: 800px)': {
      fontSize: 14,
      margin: '0',
    },
  },
  bodyTitle: {
    fontSize: '20px',
    fontWeight: 500,
    margin: '70px auto 0',
    '@media (max-width: 800px)': {
      fontSize: 14,
      margin: '60px auto 0',
    },
  },
  bodyNumber: {
    fontSize: 32,
    fontWeight: 'bold',
    margin: '15px auto 25px',
    '@media (max-width: 800px)': {
      fontSize: 24,
      margin: '12px auto 20px',
    },
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',

    margin: '0 auto',
    transform: 'translateY(25%)',
    '@media (max-width: 800px)': {
      transform: 'translateY(20%)',
    },
  },
  loginButton: {
    backgroundColor: 'rgba(0, 40, 238, 0.74)',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'normal',
    margin: '57px auto',
  },
})

export default function FailPay() {
  const classes = useStyles()

  return (
    <div className={classes.cardContainer}>
      <Card className={styles.mainPay}>
        <CardContent className={classes.cardWrap}>
          <Typography component="h1" className={classes.title} color="textSecondary">
            پرداخت ناموفق
          </Typography>
          <Typography className={classes.title2}>
            متاسفانه پرداخت شما با مشکل مواجه شد
          </Typography>
          <hr style={{ color: '#000' }} />

          <Typography className={classes.bodyTitle} component="h2">
            شماره پیگیری
          </Typography>
          <Typography className={classes.bodyNumber} component="h1">
            5786996030154
          </Typography>
        </CardContent>
      </Card>

      <Button variant="contained" className={classes.loginButton}>
        ورود به پنل کاربری
      </Button>
    </div>
  )
}
